import type { OfficeActivity } from "@foreman/protocol";

const PROVIDERS: Record<string, string> = {
  claude: "Claude Code",
  codex: "Codex",
  antigravity: "Antigravity",
  gemini: "Gemini CLI",
  grok: "Grok",
  kimi: "Kimi Code",
  qwen: "Qwen",
  opencode: "OpenCode",
  crush: "Crush",
  pi: "Pi",
  copilot: "GitHub Copilot",
  cursor: "Cursor",
};

export function providerLabel(provider: string): string {
  return PROVIDERS[provider] ?? (provider ? provider[0]!.toUpperCase() + provider.slice(1) : "Agent");
}

/** 09:41 in the phone's own clock. */
export function clock(ts: number): string {
  return new Date(ts).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
}

export type { OfficeActivity };
